import { TRPCClientError } from "@trpc/client";

const GENERIC_MESSAGE_BODY_ERROR = "Failed to load message body.";

const USER_FACING_ERROR_TYPES = new Set([
    "MAILBOX_PROVIDER_UNAVAILABLE",
    "CREDENTIAL_DISCONNECTED",
    "MAILBOX_SYNC",
]);

interface ErrorDataWithType {
    errorType?: unknown;
}

export function messageBodyErrorText(error: unknown): string {
    if (!(error instanceof TRPCClientError)) {
        return GENERIC_MESSAGE_BODY_ERROR;
    }
    const errorType = (error.data as ErrorDataWithType | undefined)?.errorType;
    if (typeof errorType === "string" && USER_FACING_ERROR_TYPES.has(errorType)) {
        return error.message;
    }
    return GENERIC_MESSAGE_BODY_ERROR;
}
